import { ListView, Layout, ResizableListView, ImageItem, ImageItemView, Overlay } from "@albelli/image-list-view"
import { Component, RefObject, createRef } from "react"
import * as React from "react"

export interface Props extends React.HTMLAttributes<HTMLDivElement> {
  items: ImageItem[]
  layout: Layout
  overlays: Overlay[]
  onScroll?: (ev: any) => void
}

/**
 * A React wrapper for a ListView of images
 */
export class ImageListView extends Component<Props> {
  private ref: RefObject<HTMLDivElement> = createRef()
  private view?: ResizableListView
  private size?: { width: number; height: number }
  private currentScrollListener: any = null

  createListView(): ResizableListView {
    const renderer = (item: ImageItem, container: HTMLElement) => new ImageItemView(item, this.props.overlays, container)
    return new ResizableListView(new ListView(this.props.items, this.props.layout, renderer))
  }

  updateScrollListener() {
    if (this.ref.current != null && this.ref.current.firstChild != null) {
      if (this.currentScrollListener != this.props.onScroll) {
        if (this.currentScrollListener) {
          this.ref.current.firstChild.removeEventListener("scroll", this.currentScrollListener)
          this.currentScrollListener = null
        }
        if (this.props.onScroll) {
          this.currentScrollListener = this.props.onScroll
          this.ref.current.firstChild.addEventListener("scroll", this.currentScrollListener)
        }
      }
    }
  }

  componentDidMount() {
    this.view = this.createListView()
    const ensureSize = () => {
      if (this.view == null) {
        return // disposed
      } else if (this.ref.current) {
        const { width, height } = (this.size = this.ref.current.getBoundingClientRect())
        if (width > 0 && height > 0) {
          this.view.render(this.ref.current)
          this.updateScrollListener()
          return
        }
      }
      setTimeout(ensureSize, 50)
    }
    ensureSize()
  }

  componentWillUnmount() {
    this.view?.destroy()
    this.view = undefined
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.overlays !== prevProps.overlays) {
      this.view?.destroy()
      this.view = this.createListView()
      if (this.ref.current) {
        this.view.render(this.ref.current)
      }
    } else {
      this.view?.listView.update((handlers) => {
        if (this.props.layout != prevProps.layout) {
          handlers.updateLayout(this.props.layout)
        }
        if (this.props.items != prevProps.items) {
          handlers.updateItems(this.props.items)
        }
        if (this.ref.current) {
          const size = this.ref.current.getBoundingClientRect()
          if (!this.size || this.size.width != size.width || this.size.height != size.height) {
            handlers.updateSize((this.size = size))
          }
        }
      })
    }
    this.updateScrollListener()
  }

  render() {
    const { ...htmlProps } = this.props
    ;["items", "layout", "overlays"].forEach((deny) => {
      delete htmlProps[deny]
    })
    return <div {...htmlProps} ref={this.ref}></div>
  }
}
